import { Organization } from '../global';

export const SUBMIT_ADV_REPORT_FORM = 'SUBMIT_ADV_REPORT_FORM';
export const RESET_ADV_REPORT_FORM = 'RESET_ADV_REPORT_FORM';

export interface AdvisorOrganizationData {
  advisorReportOrganizations?: Organization[];
  formValues?: Record<string, string | number>;
  isFormSubmitted?: boolean;
}
